import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addCart({ commit }, item) {
    return this.$axios.$post('admin/carts/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeCart({ commit }, item) {
    return this.$axios.$delete(`admin/carts/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateCart({ commit }, item) {
    return this.$axios.$put(`admin/carts/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchCart({ commit }, id) {
    return this.$axios.$get(`admin/carts/${id}`).then((response) => {
      return response.data
    })
  },
  fetchCarts({ commit }) {
    return this.$axios.$get('admin/carts').then((response) => {
      commit('load', response.data)
    })
  },
}
